export const DEFAULT_RESULTS_PER_PAGE = 60;
export const RESULTS_PER_PAGE_24 = 24;
export const RESULTS_PER_PAGE_48 = 48;

/**
 * Return the number of results per page according to the experiment behaviour
 * @param {string} behaviour - The experiment behaviour ('original', 'variant24Results', 'variant48Results')
 * @returns {number} The number of results per page
 */
export const getResultsPerPageFromBehaviour = behaviour => {
  switch (behaviour) {
    case 'variant24Results':
      return RESULTS_PER_PAGE_24;
    case 'variant48Results':
      return RESULTS_PER_PAGE_48;
    case 'original':
    default:
      return DEFAULT_RESULTS_PER_PAGE;
  }
};
